(function () {
  // Driven in JS, not CSS scroll-driven: ViewTimelines on inner SVG elements
  // are broken in Chrome. Hidden states apply only under .bq-armed, so without
  // JS or with reduced motion the wheel stays visible.
  var bq = window.bq;
  if (!bq || !('IntersectionObserver' in window)) return;
  if (bq.reducedMotion()) return;

  function init(el) {
    if (!el || el.dataset.bqLearnInit) return;
    el.dataset.bqLearnInit = '1';
    el.classList.add('bq-armed');
    var started = false;
    // Don't disconnect after the first view: the wheel runs `infinite`
    // animations (center pulse, node breathing, comet tint) that would keep
    // spinning offscreen. Pause them when the section leaves the viewport,
    // resume on return (the one-shot intro is already frozen at 100%, so the
    // pause has no effect on it).
    var io = new IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting;
      el.classList.toggle('bq-offscreen', !visible);
      if (visible && !started) {
        started = true;
        el.classList.add('is-inview');
        runComet(el);
      }
    }, { threshold: 0.15 });
    io.observe(el);
  }

  function runComet(el) {
    var head = el.querySelector('.bq-ring__comet--head');
    var tCore = el.querySelector('.bq-ring__tail--core');
    var tGlow = el.querySelector('.bq-ring__tail--glow');
    if (!head) return;
    var START = 0.8;
    var TOUR = 4;
    var END = START + TOUR;
    var TAIL = 7; // % of the circle

    function angleAt(t) {
      if (t <= START) return 0;
      if (t >= END) return 360;
      return 360 * (t - START) / TOUR;
    }

    // Trail = dash segment [pct - L, pct], L growing from 0 so it never leads the head.
    function setTail(p, pct) {
      var L = Math.min(TAIL, pct);
      p.setAttribute('stroke-dasharray', L.toFixed(2) + ' ' + (100 - L).toFixed(2));
      p.setAttribute('stroke-dashoffset', (L - pct).toFixed(2));
    }

    var t0 = performance.now();
    function frame(now) {
      var t = (now - t0) / 1000;
      var deg = angleAt(t);
      var a = deg * Math.PI / 180;
      head.setAttribute('transform', 'translate(' + (150 + 110 * Math.sin(a)).toFixed(2) + ' ' + (150 - 110 * Math.cos(a)).toFixed(2) + ')');
      var pct = deg / 3.6;
      if (tCore) setTail(tCore, pct);
      if (tGlow) setTail(tGlow, pct);
      if (t < END + 0.6) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  document.querySelectorAll('.bq-learn').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.bq-learn').forEach(init);
  });
})();
